import { createContext, useContext } from 'react';

export interface CommanderGoAnalyticsCtx {
  threadId: string;
  appContext: string;
}

export const CommanderGoAnalyticsContext = createContext<CommanderGoAnalyticsCtx | null>(null);

export function useCommanderGoAnalytics(): CommanderGoAnalyticsCtx | null {
  return useContext(CommanderGoAnalyticsContext);
}
